import React, { useState, useEffect } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import OurServices from "../Components/FillerComponents/Ourservices";
import Cardone from "../Components/Cards/Cardone";
import HimachalHeroSlider from "../Components/UI/Imagescarasoul";
import Cardprice from "../Components/Cards/Cardprice";
import TaxiComponent from "../Components/FillerComponents/Taxiservices";
import VideoShowcase from "../Components/Whatsapp/VideoShowcase";
import TopRatedLocations from "../Components/UI/TopRatedLocation";

const Home = () => {
  
  const images = [
    "https://wallpapers.com/images/hd/himalaya-pictures-1ao4uzjrpjn0nhi8.jpg",
    "https://static.toiimg.com/thumb/msid-94850960,width-748,height-499,resizemode=4,imgsize-221796/.jpg",
    "https://wallpapercave.com/wp/wp150876.jpg",
    "https://images.pexels.com/photos/1416900/pexels-photo-1416900.jpeg?cs=srgb&dl=pexels-rasikraj-1416900.jpg&fm=jpg",
  ];

  

  return (
    <Box className="home-container">

      <HimachalHeroSlider/>
     
    
      <Box>
      <Cardprice/>
      <TopRatedLocations/>
      <VideoShowcase
  bannerTitle="Our Travel Stories"
  bannerSubtitle="Real journeys, real experiences, real people"
  videoUrl="https://www.youtube.com/embed/37qM0UnjC1s"/>
<TaxiComponent />

  
      </Box>
      <OurServices />
       <Cardone />
      
    </Box>
  );
};

export default Home;
